module.exports = __webpack_public_path__ + "img/circle-check.f5efb703.svg";